import React, { useState } from "react";
import * as S from "./styles";
import assets from "~/assets";

const QrCodePix = ({ loading, base64, emv, onCopy }) => {
    const [showToast, setShowToast] = useState(false);

    const handleCopy = async () => {
        if (!emv) return;

        try {
            await navigator.clipboard.writeText(emv);

            setShowToast(true);

            setTimeout(() => {
                setShowToast(false);
            }, 2500);

            if (onCopy) onCopy();
        } catch (err) {
            console.error("Erro ao copiar Pix:", err);
        }
    };

    return (
        <>
            <S.Toast show={showToast}>
                Código Pix copiado com sucesso ✔
            </S.Toast>

            <S.Wrapper>
                <S.Title>Pagar com Pix</S.Title>

                {emv && (
                    <S.PixButton type="button" onClick={handleCopy}>
                        {assets.icons.copy}
                        Copiar código Pix
                    </S.PixButton>
                )}

                <S.QrArea>
                    {loading ? (
                        <S.QrLoading>
                            <S.QrSpinner />
                        </S.QrLoading>
                    ) : base64 ? (
                        <S.QrImage
                            src={`data:image/png;base64,${base64}`}
                            alt="QR Code Pix"
                        />
                    ) : null}
                </S.QrArea>

                
            </S.Wrapper>
        </>
    );
};

export default QrCodePix;